import { render, staticRenderFns } from "./UnitOfMeasurement.vue?vue&type=template&id=d129524a&scoped=true"
import script from "./UnitOfMeasurement.vue?vue&type=script&lang=js"
export * from "./UnitOfMeasurement.vue?vue&type=script&lang=js"
import style0 from "./UnitOfMeasurement.vue?vue&type=style&index=0&id=d129524a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d129524a",
  null
  
)

export default component.exports